import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Distribution() {
  useReveal();
  const { c } = useSite();
  const d = c.distribution;
  const { ui } = c;
  return (
    <section id="distribution" className="bg-parchment text-ink py-28 sm:py-40">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-7">
            <span className="eyebrow text-oxblood">{d.label}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl font-light leading-[1.02]">{d.title}</h2>
          <p className="mt-5 text-xl leading-relaxed text-ink/70 font-light">{d.intro}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 mt-16 items-center">
          <div className="reveal border-t-2 border-oxblood pt-8">
            <div className="font-display text-8xl sm:text-9xl font-light text-oxblood leading-none">{d.bigStat.value}</div>
            <div className="font-label text-[0.72rem] uppercase tracking-[0.22em] text-ink/60 mt-6">{d.bigStat.label}</div>
            <p className="mt-5 text-lg leading-relaxed text-ink/70 font-light max-w-md">{d.bigNote}</p>
          </div>

          <div className="grid gap-px bg-ink/15">
            {d.stats.map((s, i) => (
              <div key={i} className="reveal bg-parchment py-6" style={{ animationDelay: `${i * 80}ms` }}>
                <div className="flex items-baseline gap-5">
                  <span className="font-display text-4xl sm:text-5xl font-light text-ink w-32">{s.value}</span>
                  <span className="text-lg text-ink/70 font-light leading-snug">{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 border-t border-ink/20 pt-8">
          <p className="font-label text-[0.7rem] uppercase tracking-[0.22em] text-ink/50 mb-6">{ui.whereLive}</p>
          <div className="grid sm:grid-cols-2 gap-x-12">
            {d.places.map((pl, i) => (
              <div key={i} className="reveal flex items-center justify-between border-b border-ink/15 py-4">
                <span className="text-lg font-light">{pl.place}</span>
                <span className="font-display text-2xl text-oxblood">{pl.value}</span>
              </div>
            ))}
          </div>
          <p className="text-sm text-ink/45 font-light mt-8 italic">{d.note}</p>
        </div>
      </div>
    </section>
  );
}
